import { Controller } from '@hotwired/stimulus'

interface ContactFormEvent extends Event {
  params: {
    type: string
  }
}

export default class extends Controller {
  static targets = ['form', 'text', 'field', 'submitButton']
  static values = { locale: String, submitting: Boolean }

  declare readonly formTarget: HTMLFormElement
  declare readonly textTargets: HTMLElement[]
  declare readonly submitButtonTarget: HTMLButtonElement
  declare readonly fieldTargets: HTMLElement[]
  declare readonly localeValue: string
  declare timer: ReturnType<typeof setTimeout>
  declare submittingValue: boolean
  formType: string = 'none'

  connect() {
    const params = new URLSearchParams(window.location.search)
    const contactKindParams = params.get('contact_kind')
    if (contactKindParams) {
      this.formType = contactKindParams
    }
    this.updateForm()
  }

  switchForm(event: ContactFormEvent) {
    event.preventDefault()

    if (event.params) {
      this.formType = event.params.type
    }

    this.updateForm()
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  updateForm() {
    this.fieldTargets.forEach((target) => {
      if (target.dataset.formTypes && target.dataset.formTypes.includes(this.formType)) {
        target.querySelectorAll('input, textarea, select').forEach((element) => {
          (element as HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement).disabled = false
        })
        target.classList.remove('is-hidden')
      } else {
        target.querySelectorAll('input, textarea, select').forEach((element) => {
          (element as HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement).disabled = true
        })
        target.classList.add('is-hidden')
      }
    })

    this.textTargets.forEach((target) => {
      if (target.dataset.formTypes && target.dataset.formTypes.includes(this.formType)) {
        target.classList.remove('is-hidden')
      } else {
        target.classList.add('is-hidden')
      }
    })
  }

  submitWithValidation(event: Event) {
    if (this.submittingValue) {
      event.preventDefault()
      return
    }

    if (this.validation(event)) {
      this.setTimestamp()

      this.submittingValue = true
      this.submitButtonTarget.disabled = true
      this._startResetTimer()
    }
  }

  validation(event: Event) {
    const nameInput = document.getElementById('contact_form_name') as HTMLInputElement
    const emailInput = document.getElementById('contact_form_email') as HTMLInputElement
    if (nameInput && nameInput.value === '') {
      alert(this.localeValue === 'ja' ? 'お名前は必須項目です' : 'name is a required field')
      event.preventDefault()
      return
    }
    if (emailInput && emailInput.value === '') {
      alert(this.localeValue === 'ja' ? 'メールアドレスは必須項目です' : 'email is a required field')
      event.preventDefault()
      return
    }
    return true
  }

  _reset() {
    this.submittingValue = false
    this.submitButtonTarget.disabled = false
  }

  _startResetTimer() {
    this.timer = setTimeout(() => {
      this._reset()
    }, 60000)
  }

  setTimestamp() {
    const date = new Date()
    const timestampInput = document.getElementById('timestamp')
    if (timestampInput instanceof HTMLInputElement) {
      timestampInput.value = date.getTime().toString()
    }
  }
}
